export default __webpack_public_path__ + "static/media/sale.761fa111.png";